import React, { useMemo } from 'react';
import { WorldSection } from './WorldPageHeader';
import { StatusBadge } from './VerificationBits';
import { CopyTextButton } from './CopyTextButton';
import { buildDiagnostic } from '../../utils/caseDiagnostics';
import { useWorld } from '../../contexts/WorldDataContext';
import type { WorldData } from '../../types/world';
const badge = {
  confirmed: 'match',
  review: 'info',
  pending: 'info',
  disabled: 'mismatch',
  'no-routes': 'mismatch',
  'not-found': 'unavailable'
} as const;
const label = {
  confirmed: 'Visible',
  review: 'En revisión',
  pending: 'Falta información',
  disabled: 'Desactivado',
  'no-routes': 'Sin rutas',
  'not-found': 'No encontrado'
} as const;

/** Diagnóstico copiable: ejemplos + resumen de todos los ítems. */
export function DiagnosticReport({
  w
}: {
  w: WorldData;
}) {
  const {
    docs
  } = useWorld();
  const d = useMemo(() => buildDiagnostic(w, docs), [w, docs]);
  return <WorldSection id="diagnostico" title="Diagnóstico copiable" data-id="element-1145" data-mp="2qq3cho43cj89">
      <p className="text-sm text-gray-400" data-id="element-1146" data-mp="26w4chw55uxut">
        Se calcula en este navegador con los archivos cargados ahora. Separa registros originales, rutas desactivadas, rutas en revisión y lo visible para el jugador. Incluye el catálogo completo, las variantes y los casos de prueba.
      </p>

      {d.loadErrors.length > 0 && <p className="mt-3 rounded-xl border border-red-400/30 p-3 text-sm text-red-200" data-id="element-1147" data-mp="224w515ne5mka">
          Errores de carga: {d.loadErrors.map(r => r.label).join(', ')}. El diagnóstico puede estar incompleto.
        </p>}

      <ul className="mt-4 flex flex-wrap gap-2" data-id="element-1148" data-mp="1s813edvtn61s">
        {d.examples.map(e => <li key={e.label} className="flex items-center gap-2 rounded-full border border-white/10 py-1 pl-3 pr-1 text-sm text-gray-200" data-id="element-1149" data-mp="1e8i9oq3rbx90">
            {e.label}: {e.query}
            <StatusBadge status={badge[e.verdict]} label={label[e.verdict]} data-id="element-1150" data-mp="38lrazum5gcg6" />
          </li>)}
      </ul>

      <div className="mt-4 flex flex-wrap gap-2" data-id="element-1151" data-mp="3dl47l72toxvy">
        <CopyTextButton text={d.report} label="Copiar diagnóstico" data-id="element-1152" data-mp="3djt2n3xn5k39" />
        <CopyTextButton text={d.affectedList} label={`Copiar ítems pendientes (${d.affectedCount})`} data-id="element-1153" data-mp="3b6z4tcwfutyi" />
      </div>

      <pre className="mt-4 max-h-[520px] overflow-auto whitespace-pre-wrap rounded-2xl border border-white/10 bg-[#050b14] p-4 font-mono text-[12px] leading-relaxed text-gray-300" data-id="element-1154" data-mp="372rcl5qruvvj">{d.report}</pre>
    </WorldSection>;
}